import styled from 'styled-components';

export const StyledNotFound = styled.div`
  font-family: Poppins,Heltica,Arial,sans-serif;
  font-size: 14px;
`;
